import React from "react";
import styles from "./ExhibitionSection.module.scss";
import ReactReadMoreReadLess from "react-read-more-read-less";
import eventImage from "../../../assets/images/event-image.jpg";

const event = {
  id: 1,
  image: eventImage,
  title: "Tittle Of The Event",
  date: "Nov 05-24, 2024",
  location: "Paris, Bordeaux",
  description:
    "Name Lastname belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going throut. Name Lastname belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.",
};

const ExhibitionSection = () => {
  return (
    <div className={`eventsRef ${styles.exhibitionSectionContainer}`}>
      <div className="container">
        <div className={styles.title}>Exhibitions and Events </div>
        <div className={styles.exhibitionList}>
          {Array.from(Array(4), (_, index) => (
            <div
              key={index}
              className={`${styles.card} ${
                index % 2 === 0 ? styles.textFirst : ""
              }`}
            >
              <div className={styles.cardImage}>
                <img src={event.image} alt={event.title} />
              </div>
              <div className={styles.info}>
                <h2>{event.title}</h2>
                <div className={styles.date}>{event.date}</div>
                <div className={styles.location}>{event.location}</div>
                <p className={styles.desc}>
                  <ReactReadMoreReadLess
                    charLimit={200}
                    readMoreText={"Read more ▼"}
                    readLessText={"Read less ▲"}
                  >
                    {event.description}
                  </ReactReadMoreReadLess>
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.loadMore}>
          <button>Load More</button>
        </div>
      </div>
    </div>
  );
};

export default ExhibitionSection;
